import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProviderWorkspaceComponent } from '@app/workspace/components/provider-workspace/provider-workspace.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule, Routes } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { ProviderBaaSignatureComponent } from '@app/workspace/components/provider-baa-signature/provider-baa-signature.component';
import { PlCommonModule } from '@app/common/common.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ScheduleCardComponent } from '@app/workspace/components/schedule-card/schedule-card.component';
import { OnboardingToolkitCardComponent } from '@app/workspace/components/onboarding-toolkit-card/onboarding-toolkit-card.component';
import { QuickLinksCardComponent } from '@app/workspace/components/quick-links-card/quick-links-card.component';
import { NeedAssistanceCardComponent } from '@app/workspace/components/need-assistance-card/need-assistance-card.component';
import { EventService } from '@app/calendar/services/event.service';

const ROUTES: Routes = [{ path: '', component: ProviderWorkspaceComponent }];

@NgModule({
  declarations: [
    ProviderWorkspaceComponent,
    ProviderBaaSignatureComponent,
    ScheduleCardComponent,
    OnboardingToolkitCardComponent,
    QuickLinksCardComponent,
    NeedAssistanceCardComponent,
  ],
  imports: [
    PlCommonModule,
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    RouterModule.forChild(ROUTES),
  ],
  providers: [EventService],
})
export class ProviderWorkspaceModule {}
